<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>

    <el-card class="box-card">
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">单位名</div>
          <div class="form_box__group__item__content">{{partyname}}</div>
        </div>
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">平均学习课时</div>
          <div class="form_box__group__item__content">{{scoreavg}}</div>
        </div>
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">共开设课程</div>
          <div class="form_box__group__item__content">{{courses}}</div>
        </div>

        <div class="form_box__group__item">
              <el-divider content-position="left">人员信息</el-divider>
        </div>

        <div class="form_box__group__item">
           <div class="form_box__group__item__title">
             <el-input v-model="searchword" placeholder="筛选用户信息"></el-input>
            </div>

              <el-button type="primary" @click="exportUnit" :loading="downloading">导出</el-button>
          <!-- <div class="form_box__group__item__content">{{courses}}</div>  -->
        </div>

        <el-table
          :data="showdatas"
          stripe
          style="width: 800px">
          <el-table-column
            prop="name"
            label="姓名"
            width="180">
          </el-table-column>
          <el-table-column
            prop="scoreThisYear"
            label="当年所获学时">
          </el-table-column>
          <el-table-column
            prop="scoreOverYears"
            label="历年获得学时">
          </el-table-column>
          <el-table-column
            prop="leaveNumber"
            label="请假次数">
          </el-table-column>
        </el-table>
    </el-card>




  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { detailPartyOrgApi, exportPartyOrgApi } from '@/api/module/export/export';

export default {
  name: "ExportClassunitDetail",
  
  mixins: [BaseVue],

  data() {
    return {
      id: "",
      partyname: "", // 单位名
      scoreavg: "",  // 平均学习课时
      courses: 0, // 共开设课程
      datas: [],
      showdatas: [],
      searchword: "",  // 搜索文字
      downloading: false
    };
  },
  
  methods: {
    init() {
      detailPartyOrgApi(this.id)
        .then((r) => {
          this.partyname = r.partyName;
          this.scoreavg = r.scoreAvg;
          // this.courses = r.courses;
          this.datas = r.userScoreDetailBeanList;
          this.showdatas = this.datas;
        });
    },
    
    exportUnit() {
      this.downloading = true;
      let data = {
        datas: this.showdatas
      };
      
      exportPartyOrgApi(data)
        .then((res) => {
          let data = res.data;
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', '支部信息.xlsx');
          document.body.appendChild(link);
          link.click();
          this.downloading = false;
        });
    }
  },
  
  watch: {
    searchword(newVal) {
      if (newVal) {
        let d = this.datas.filter(item => {
          return item.name.indexOf(newVal) > -1;
        });
        this.showdatas = d;
      } else {
        this.showdatas = this.datas;
      }
    }
  },
  
  beforeMount() {
    // 组件挂载前的逻辑
  },
  
  mounted() {
    this.id = this.$route.query.id;
    this.init();
  }
};
</script>


<style scoped>
</style>